import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ITextItemMediaSettingsDialogData } from '@fi-shared/fi-text-item-helper/fi-text-item-media';
import { FiDisplayAs } from '@fi-shared/types/display-as';
import { FileType } from '@fi-shared/types';
import { TextItemMediaClickActionType } from '@fi-shared/types/text-item-media-click-action-type';
import { MediaBankStorageType } from '@fi-shared/media-bank/media-bank-storage-type';

@Component({
    selector: 'fi-text-item-media-settings-dialog',
    templateUrl: './fi-text-item-media-settings-dialog.component.html',
    styleUrls: ['./fi-text-item-media-settings-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-text-item-media-settings-dialog' },
    standalone: false,
})
export class FiTextItemMediaSettingsDialogComponent
    extends FiDialogsContentBase<ITextItemMediaSettingsDialogData, ITextItemMediaSettingsDialogData>
    implements OnInit
{
    fiDisplayAs = FiDisplayAs;
    textItemMediaClickActionType = TextItemMediaClickActionType;

    ngOnInit() {
        this.handleEmptyLinkText();
    }

    handleEmptyLinkText() {
        if (!this.data.linkTextValue.trim()) {
            this.data.linkTextValue = this.getFileName();
        }
    }

    getFileName(): string {
        return this.data.textItemMediaModel.file.Name + this.data.textItemMediaModel.file.Extension;
    }

    setDisplayAsType(displayType: number): void {
        this.data.textItemMediaModel.displayAs = displayType;
        this.setClickActionType(displayType);
    }

    isDisplayTypeSelected(displayType: number): boolean {
        return displayType === this.data.textItemMediaModel.displayAs;
    }

    isOnlyDownloadableFile(): boolean {
        return (
            this.data.textItemMediaModel.file.FileType !== FileType.Image &&
            this.data.textItemMediaModel.file.FileType !== FileType.Movie &&
            !this.isVimeoStorage()
        );
    }

    isVimeoStorage() {
        return this.data.textItemMediaModel.file.StorageType === MediaBankStorageType.Vimeo;
    }

    isOnClickActionTypeSelectDisabled(): boolean {
        return this.isOnlyDownloadableFile() || this.isVimeoStorage();
    }

    private setClickActionType(displayType: number): void {
        if (displayType === this.fiDisplayAs.Image.Id) {
            this.data.textItemMediaModel.onClickActionType = this.textItemMediaClickActionType.EnlargedView;
        } else if (displayType === this.fiDisplayAs.DownloadableFile.Id) {
            this.data.textItemMediaModel.onClickActionType = this.textItemMediaClickActionType.DownloadFile;
        }
    }
}
